var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedAreaBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_15128_146496)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 12.5,
    width: 53,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 32V20H33.5",
    stroke: "#0089EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 57.5H21V45",
    stroke: "#0089EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 20H60V32.5",
    stroke: "#0089EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 57.5H60V45",
    stroke: "#0089EC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 39.25C44.366 39.25 47.5 36.116 47.5 32.25C47.5 28.384 44.366 25.25 40.5 25.25C36.634 25.25 33.5 28.384 33.5 32.25C33.5 36.116 36.634 39.25 40.5 39.25ZM49.5459 43.9112C52.0777 46.2554 53.5 49.4348 53.5 52.75H40L26.5 52.75C26.5 49.4348 27.9223 46.2554 30.4541 43.9112C32.9858 41.567 36.4196 40.25 40 40.25C43.5804 40.25 47.0142 41.567 49.5459 43.9112Z",
    fill: "#0089EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_15128_146496",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15128_146496"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_15128_146496",
    result: "effect2_dropShadow_15128_146496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_15128_146496",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAreaBlue);
export default __webpack_public_path__ + "static/media/restricted-area-blue.ed385536d55cde0693325e1278e77955.svg";
export { ForwardRef as ReactComponent };